import axios from "axios";
import {
  ClientBillingTier,
  CreateClientBillingTier,
  UpdateClientBillingTier,
} from "../../Types/ClientBilling";
import { EndpointErrorResponse } from "../../Types/ClientServiceApi";

export const getClientBillingTiers = async () => {
  const res = await axios.get<ClientBillingTier[] | EndpointErrorResponse>(
    import.meta.env.VITE_CLIENTSERVICE_API + "/client/billingtiers",
    { validateStatus: () => true }, // Ignore axios status code validation
  );

  if (Array.isArray(res.data)) {
    return res.data as ClientBillingTier[];
  } else {
    throw new Error((res.data as EndpointErrorResponse).detail);
  }
};

export const createClientBillingTier = async (newTier: CreateClientBillingTier) => {
  const res = await axios.post<ClientBillingTier | EndpointErrorResponse>(
    import.meta.env.VITE_CLIENTSERVICE_API + "/client/createbillingtier",
    newTier,
    { validateStatus: () => true }, // Ignore axios status code validation
  );
  if (res.data.status !== undefined) {
    throw new Error((res.data as EndpointErrorResponse).detail);
  }
  return res.data as ClientBillingTier;
};

export const updateClientBillingTier = async (editedTier: UpdateClientBillingTier) => {
  const res = await axios.put<ClientBillingTier | EndpointErrorResponse>(
    import.meta.env.VITE_CLIENTSERVICE_API + "/client/updatebillingtier",
    editedTier,
    { validateStatus: () => true }, // Ignore axios status code validation
  );
  if (res.data.status !== undefined) {
    throw new Error((res.data as EndpointErrorResponse).detail);
  }
  return res.data as ClientBillingTier;
};
